import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles.css';
import 'react-datepicker/dist/react-datepicker.css';
import { useUsers } from '../contexts/UsersContext';
import { useHabits } from '../contexts/HabitsContext';
import { useHabitObservations } from '../contexts/HabitObservationsContext';

export default function Points({ apiUrl, isAdmin }) {
  const [pointSpending, setPointSpending] = useState([]);
  const [showPointSpending, setShowPointSpending] = useState(false);
  const { users } = useUsers();
  const { habits } = useHabits();
  const { habitObservations } = useHabitObservations();

  useEffect(() => {
    fetchPointSpending();
  }, [isAdmin]);

  const fetchPointSpending = () => {
    const fullPointSpendingUrl = `${apiUrl}/point_spending`;
    axios
      .get(fullPointSpendingUrl, { withCredentials: true })
      .then((response) => {
        console.log('Received point spending:', response.data);
        setPointSpending(response.data);
      })
      .catch((error) => {
        console.log('Error fetching point spending:', error);
        setPointSpending([]);
      });
  };

  const handleCreatePointSpending = (userId) => {
    const pointsSpent = parseInt(prompt('How many points were spent?', '1'), 10);
    const description = prompt('What was it used on?', '');

    if (!pointsSpent || !description) return;

    const createUrl = `${apiUrl}/point_spending`;
    const newPointSpending = {
      user_id: userId,
      points_spent: pointsSpent,
      description,
    };

    axios
      .post(createUrl, newPointSpending, { withCredentials: true })
      .then((response) => {
        console.log(
          `Point spending for user '${userId}' created successfully.`,
          response.data
        );
        setPointSpending((prevPointSpending) => [
          ...prevPointSpending,
          response.data,
        ]);
      })
      .catch((error) => {
        console.error(
          `Error creating point spending for user '${userId}:`,
          error
        );
        alert('Failed to create the point spending. Please try again.');
      });
  };

  const handleDeletePointSpending = (pointSpendingId) => {
    const confirmDelete = window.confirm(
      'Are you sure you want to delete this item?'
    );
    if (!confirmDelete) {
      return;
    }

    const deleteUrl = `${apiUrl}/point_spending/${pointSpendingId}`;
    axios
      .delete(deleteUrl, { withCredentials: true })
      .then(() => {
        console.log(
          `Point Spending with ID ${pointSpendingId} deleted successfully.`
        );
        setPointSpending((prevPointSpending) =>
          prevPointSpending.filter(
            (pointSpendingItem) => pointSpendingItem.id !== pointSpendingId
          )
        );
      })
      .catch((error) => {
        console.error(
          `Error deleting point spending with ID ${pointSpendingId}:`,
          error
        );
        alert('Failed to delete the item. Please try again.');
      });
  };

  const findHabitsByUserId = (userId) => {
    return habits.filter((habit) => habit.user_id == userId);
  };

  const findUserById = (userId) => {
    return users.find((u) => u.id === userId);
  };

  const calculatePointsEarned = (userId) => {
    const userHabits = findHabitsByUserId(userId);
    const userHabitIds = userHabits.map((habit) => habit.id);
  
    return habitObservations
      .filter((obs) => userHabitIds.includes(obs.habit_id))
      .reduce((total, observation) => total + (observation.points || 0), 0);
  };

  const calculatePointsSpent = (userId) => {
    return pointSpending
      .filter((spending) => spending.user_id === userId)
      .reduce((total, spending) => total + (spending.points_spent || 0), 0);
  };

  return isAdmin ? (
    <div className="point-spending-container">
      <h2>Point Totals</h2>
      <table className="custom-table">
        <thead>
          <tr>
            <th>User</th>
            <th>Points Earned</th>
            <th>Points Spent</th>
            <th>Points Left</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => {
            const pointsEarned = calculatePointsEarned(user.id);
            const pointsSpent = calculatePointsSpent(user.id);
            const pointsLeft = pointsEarned - pointsSpent;

            return (
              <tr key={user.id}>
                <td>{user.name}</td>
                <td>{pointsEarned}</td>
                <td>{pointsSpent}</td>
                <td>{pointsLeft}</td>
                <td>
                  <button onClick={() => handleCreatePointSpending(user.id)}>
                    Spend
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <h2>
        Point Spending Details
        <button
          onClick={() => setShowPointSpending((prev) => !prev)}
          style={{ marginLeft: '10px' }}
        >
          {showPointSpending ? 'Hide' : 'Show'}
        </button>
      </h2>

      {showPointSpending && (
        <table className="custom-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>User</th>
              <th>Description</th>
              <th>Points Spent</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {pointSpending.map((pointSpendingItem) => {
              const user = findUserById(pointSpendingItem.user_id);

              return (
                <tr key={pointSpendingItem.id}>
                  <td>{pointSpendingItem.id}</td>
                  <td>{user ? user.name : 'Unknown User'}</td>
                  <td>{pointSpendingItem.description}</td>
                  <td>{pointSpendingItem.points_spent}</td>
                  <td>
                    <button
                      onClick={() =>
                        handleDeletePointSpending(pointSpendingItem.id)
                      }
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  ) : null;
}
